/*
  Butonul de checkout, si cel din sertar si cel de pe pagina /cart, este un buton de
  tip submit intr-un formular care trimite POST catre /cart. Pe langa trecerea la
  checkout, retrimite astfel cantitatea fiecarei linii din cos, prin campurile updates[].

  updates[] este pozitional: Shopify aplica valorile in ordine, peste liniile existente
  in acel moment. Liniile de cadou adaugate de app-ul EG Auto Add to Cart sunt insa
  recreate la fiecare schimbare de cantitate si isi schimba cheia. Cand actualizarea
  ajunge peste o linie recreata, cosul este distrus, iar Shopify, negasind cos, duce
  clientul pe pagina principala.

  Aici nu mai trimitem formularul deloc: mergem direct la checkout. Fara POST, nu se
  trimit cantitati, deci nimic nu mai poate ateriza peste linia gresita.

  Nu ne atingem de formular. O varianta anterioara scotea campurile si trimitea tot
  formularul mai tarziu; nu functioneaza, fiindca dupa o schimbare de cantitate tema
  re-randeaza sertarul si sterge intre timp tot ce pregatisem. Navigarea nu depinde de
  nicio bucata de DOM, deci nu poate fi anulata asa.

  Asteptam inainte de a pleca doar cand chiar e nevoie. Cantitatile si nota se salveaza
  prin AJAX, dar cu un debounce de 300ms (ON_CHANGE_DEBOUNCE_TIMER din
  assets/constants.js). Daca tocmai s-a schimbat ceva, plecarea imediata ar pierde acea
  modificare. Daca insa nu s-a atins nimic de curand si cosul nu e in lucru, plecam pe
  loc, ca butonul sa nu para blocat.
*/
(function () {
  'use strict';

  // Peste debounce-ul de 300ms, ca salvarea in asteptare sa apuce sa plece.
  var ASTEPTARE_DEBOUNCE = 400;
  // Sub aceasta vechime, o modificare e considerata inca in lucru.
  var PRAG_MODIFICARE_RECENTA = 1500;
  // Cat timp cart.js tine cosul in stare de incarcare.
  var SELECTOR_OCUPAT = '.cart__items--disabled';
  var PAS_VERIFICARE = 100;
  var ASTEPTARE_MAXIMA = 3000;
  // Dupa atat, butonul redevine apasabil chiar daca navigarea nu s-a produs.
  var DEBLOCARE = 5000;

  var ultimaModificare = 0;
  var inCurs = false;

  /*
    Cand clientul se intoarce cu Back de la checkout, browserul nu reincarca pagina,
    ci o restaureaza din memorie exact cum era, cu tot cu variabilele scriptului. Fara
    randurile de mai jos, `inCurs` ramane pornit de la apasarea dinainte si butonul de
    checkout nu mai raspunde niciodata pe pagina aceea. Reprodus pe magazin: dupa Back,
    clicul era interceptat dar nu se mai pleca nicaieri.
  */
  window.addEventListener('pageshow', function () {
    inCurs = false;
  });

  document.addEventListener(
    'change',
    function (event) {
      var t = event.target;
      if (!t || !t.getAttribute) return;
      var nume = t.getAttribute('name');
      if (nume === 'updates[]' || nume === 'note') ultimaModificare = Date.now();
    },
    true
  );

  function cosulEOcupat() {
    return !!document.querySelector(SELECTOR_OCUPAT);
  }

  function modificareRecenta() {
    return Date.now() - ultimaModificare < PRAG_MODIFICARE_RECENTA;
  }

  function adresaCheckout() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/') + 'checkout';
  }

  function pleaca() {
    window.location.href = adresaCheckout();
  }

  function candCosulELiber(callback) {
    var asteptat = 0;
    setTimeout(function verifica() {
      if (!cosulEOcupat() || asteptat >= ASTEPTARE_MAXIMA) {
        callback();
        return;
      }
      asteptat += PAS_VERIFICARE;
      setTimeout(verifica, PAS_VERIFICARE);
    }, ASTEPTARE_DEBOUNCE);
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      var btn = target && target.closest ? target.closest('[name="checkout"]') : null;
      if (!btn || btn.disabled) return;

      // Butonul de checkout e drumul critic al magazinului. Daca ceva neasteptat apare
      // aici, lasam comportamentul original al temei sa mearga mai departe, ca butonul
      // sa nu ramana fara efect.
      try {
        event.preventDefault();
        if (inCurs) return;
        inCurs = true;

        // Plasa de siguranta: daca navigarea nu se produce din orice motiv, butonul
        // trebuie sa redevina apasabil. Altfel ar ramane mort pana la reincarcare.
        setTimeout(function () {
          inCurs = false;
        }, DEBLOCARE);

        if (!modificareRecenta() && !cosulEOcupat()) {
          pleaca();
          return;
        }

        candCosulELiber(pleaca);
      } catch (e) {
        inCurs = false;
      }
    },
    true
  );
})();
